












import { Component, Prop, Vue } from 'vue-property-decorator'
import RemoveTag from '@/components/Parts/RemoveTag.vue'

const basePath = drupalSettings.path.baseUrl

/**
 * パンくずデータクラス
 */
export class BreadcrumbItem {
  private _id: string
  private _label: string
  private _url: string

  /**
   * コンストラクタ
   * @param id 識別子
   * @param label 表示文字
   * @param url リンク先
   */
  constructor(id: string, label: string, url: string) {
    this._id = id
    this._label = label
    this._url = basePath + url.replace(/^\//, '')
  }

  get id(): string {
    return this._id
  }

  get url(): string {
    return this._url
  }

  get label(): string {
    return this._label
  }
}

@Component({
  components: { RemoveTag }
})
export default class BreadcrumbsView extends Vue {
  @Prop() private items!: BreadcrumbItem[]
}
